// extracted by mini-css-extract-plugin
module.exports = {"skeleton-tender-card-list":"tenders_skeleton-tender-card-list__2mFgy","tabpanel-container":"tenders_tabpanel-container__3_Zbc"};